import { RcButton, RcIcon, styled } from '@ringcentral/juno';
import { onMobile } from '@/core/sc';
import { applyProximaNovaRegular } from '@/shared/theme/utils/typography';

export const ButtonWrapper = styled(RcButton)`
  display: inline-flex;
  align-items: center;
  padding: 0 !important;
  font-size: 16px !important;
  font-weight: normal !important;
  ${applyProximaNovaRegular()};

  ${onMobile} {
    margin-top: 20px !important;
  }

  a {
    ${applyProximaNovaRegular()};
  }

  &:hover {
    a {
      text-decoration: underline;
    }
  }
`;

export const StyledText = styled.span`
  vertical-align: middle;

  a {
    font-size: 15px !important;
    font-weight: normal !important;
    ${applyProximaNovaRegular()};
  }

  ${onMobile} {
    a {
      font-size: 20px !important;
      line-height: 24px;
    }
  }
`;

export const StyledIcon = styled(RcIcon)`
  margin-left: 6px;

  ${onMobile} {
    width: 20px;
    height: 20px;

    svg {
      width: 100%;
      height: 100%;
    }
  }
`;
